// Shared player-app constants and tiny helper functions, extracted from
// PlayerApp.jsx so individual sub-components can pull them in without
// dragging in the whole 4k-line orchestrator file.

// NEON is the platform's signature accent. Resolved at runtime via the
// `--vl-neon` CSS custom property (set by TenantThemeProvider) with the
// Mystic-Reels green as the hard-coded fallback so any tenant without a
// custom theme still looks identical to before.
export const NEON = 'var(--vl-neon, #004D61)';
// Iter 1: serviceemp wallet/game cash is now USD-pegged 1:1. The old
// 10xp=$1 frontend multiplier caused $10 to behave like 100 in game loads
// and 1 in some wallet flows. Keep the helper names for compatibility, but
// make the conversion identity-based.
export const XP_PER_DOLLAR = 1;
export const xpToUsd = (xp) => (Math.round((parseFloat(xp) || 0) * 100) / 100);
export const usdToXp = (usd) => (Math.round((parseFloat(usd) || 0) * 100) / 100);

/**
 * Fires a tiny haptic pulse on every meaningful touch. No-op on desktop /
 * unsupported environments.
 */
export const tap = (ms = 10) => {
  try {
    if (typeof navigator !== 'undefined' && typeof navigator.vibrate === 'function') {
      navigator.vibrate(ms);
    }
  } catch { /* ignore */ }
};

// Configurable social channels for the support menu (used as link prefixes).
export const SOCIAL_LINKS = {
  facebook: 'https://www.facebook.com/',
  telegram: 'https://t.me/',
};
